module.exports = __webpack_public_path__ + "img/analytics_icon_pink.61e33db1.svg";